<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolSubscriptionSubmenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/subscription/portal-subscription",
                title: "Portal Subscription",
                description: "Review and manage the school portal subscription.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/sms-subscription",
                title: "SMS Subscription",
                description: "Manage SMS plans, balances, and subscription details.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
